import {getValueCeiling} from '../../../helpers/get-value-ceiling.js'
import {getRandomInRange} from '../../../helpers/numbers-helper.js'
import {randomFromArray} from '../../../helpers/random-from-array.js'

export function getHpChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

  //Copy the changes.
  let changes = {
    ...currentCombatantStateChanges
  };

  const casterModel = combatantModels[combatantMap.casterId];

  //Remember, recover items have Caster as the Target too, and the Target is what we're looking at.
  //Haven't needed to truly affect Caster HP yet (would be for a blowback kind of move)

  //Static 1 hit
  if (action.affectTargetHpPoints !== 0) {

    //Possibly narrow an array of targets down to 1 random one (EX: Promise)
    let targetIds = [...combatantMap.targetIds];


    if (action.selectRandomTargetForSingleHit) {
      targetIds = [randomFromArray(targetIds)]; //Turn array of many into array of 1.
    }


    targetIds.forEach(targetId => {

      const targetModel = combatantModels[targetId];
      const isHealing = (action.affectTargetHpPoints > 0);

      const damageAdjustment = isHealing ? (
        //Provide the healing value, but no more than the target's max recovery amount
        // EX: maxHp - current hp. EX: max 50 - now 48, can only recover 2 hp.
        getValueCeiling(action.affectTargetHpPoints, targetModel.maxHp - targetModel.hp)
      ) : (
        //If this is an attack, use the attack calc
        casterModel.getAttackCalc(
          action.affectTargetHpPoints,
          targetModel,
          action.statusMultiplier,
          action.actionMeta.hasTimedHitBonus,
          action.bypassCasterAttackStats
        )
      );

      changes.state[targetId].hp = getValueCeiling(targetModel.hp + damageAdjustment, targetModel.maxHp); //New damage value. damageAdjustment is NEGATIVE for losing HP

      //Document the diff
      changes.description.hpDamage = changes.description.hpDamage || {};
      changes.description.hpDamage[targetId] = damageAdjustment;  //Note, this doesn't account for ceiling value.
                                                                  // EX: 45 hp recover +20, max at 50 HP. This will report 20, not 5.
    });
  }


  //Repetitions
  if (action.affectTargetHpPointsInRepetitions) {
    //Model looks like this: {min:1, max: 4, affectTargetHpPoints: -4}

    const repetitionModel = action.affectTargetHpPointsInRepetitions;
    const iterationCount = getRandomInRange(repetitionModel.min, repetitionModel.max);

    //Build up an object that contains each Hit on individual targets
    let targetsDamageTracker = {};
    for (let i = 1; i <= iterationCount; i++) {

      const targetModel = combatantModels[randomFromArray(combatantMap.targetIds)]; //For each iteration, get a random target
                                                                                    //Single-opponents will always be the same, but at least this opens the door to multi target iterations
      targetsDamageTracker[targetModel.id] = targetsDamageTracker[targetModel.id] || [];
      targetsDamageTracker[targetModel.id].push({
        hpAdjustment: casterModel.getRepetitionHitCalc( repetitionModel.affectTargetHpPoints ), //TODO: use a calculation function here
        order: i,
        combatantId: targetModel.id //This will help give an interface for ordering the animation
      });
    }

    //Save the hit tracking object to the description object
    changes.description.targetsDamageTracker = targetsDamageTracker;

    //Deliver the final values of new HP
    Object.keys(targetsDamageTracker).forEach(targetId => {
      const targetModel = combatantModels[targetId];
      const totalDamage = targetsDamageTracker[targetId].map(iteration => iteration.hpAdjustment).reduce((a, b) => a + b);
      //Note that we're assuming this is the only type of HP damage this action will do. It's wiping out whatever this target's new HP was. (if it existed)
      //No Actions use both yet (if ever), so we're cool for now. In the future, may need to check what `changes.state[targetId].hp` is first before setting
      changes.state[targetId].hp = targetModel.hp + totalDamage;

      //Track the hpDamage changes for description object
      changes.description.hpDamage = changes.description.hpDamage || {};
      changes.description.hpDamage[targetId] = totalDamage;
    });
  }


  //Percentages
  if (action.affectTargetHpPointsByPercent !== 0) {
    combatantMap.targetIds.forEach(targetId => {

      const targetModel = combatantModels[targetId];
      const damageAdjustment = Math.round(action.affectTargetHpPointsByPercent * targetModel.maxHp); //Percent is 0.15, 0.5, -0.75 etc

      let targetHp = targetModel.hp > 0 ? targetModel.hp : 0; //Don't start with a negative number if recovering

      changes.state[targetId].hp = getValueCeiling(targetHp + damageAdjustment, targetModel.maxHp);

      //Document the diff
      changes.description.hpDamage = changes.description.hpDamage || {};
      changes.description.hpDamage[targetId] = damageAdjustment; //Same deal.. this will report the wanted change, ignores ceiling values
    });
  }

  return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/hp.js